export default __webpack_public_path__ + "static/connectsmall-737548838df2b733b87d23c8635acfd2.png";